module.exports = __webpack_public_path__ + "img/b5-3.c9b67e8.png";